import { defineStore, createPinia } from 'pinia'
import { createState } from './state'

const pinia = createPinia()

export const createStore = () => {
  window.globalStore = defineStore('store', {
    // 为了完整类型推理，推荐使用箭头函数
    state: createState,
    getters: {
      doubleCount: (state) => state.count * 2,
    },
    actions: {
      // 增加字段
      addCsrState(key, obj) {
        this.csrState = {
          ...this.csrState,
          [key]: obj,
        };
      },
      // 删除字段
      delCsrState(key) {
        delete this.csrState[key];
      },
      // 给单个字段赋值
      setCsrStateValue(key, value, setProp="value") {
          this.csrState[key][setProp] = JSON.parse(JSON.stringify(value))
      },
      // 给单个字段设置Config
      setCsrConf(key, conf) {
          this.csrState[key].conf = conf
      },
    },
  })(pinia)
};

export const getStore = () => {
  return window.globalStore;
};
